import { call, put, takeLatest } from 'redux-saga/effects'
import { getUserMetadata } from "../api"
import { FETCH_USER_METADATA_REQUEST, FETCH_USER_METADATA_SUCCESSFUL, FETCH_USER_METADATA_ERROR } from "../actions"

function* fetchUserMetadata(action) {
    try {
        const userMetadata = yield call(getUserMetadata);
        yield put({
            type: FETCH_USER_METADATA_SUCCESSFUL,
            payload: { ...userMetadata }
        });
    } catch (e) {
        console.error(e);
        yield put({
            type: FETCH_USER_METADATA_ERROR,
            message: e.message
        });
    }
}

export default function*() {
    yield takeLatest(FETCH_USER_METADATA_REQUEST, fetchUserMetadata);
}



// WEBPACK FOOTER //
// ./src/sagas/userMetadata.js